import * as React from 'react';
import { Layout } from 'antd';

import { DocLayout } from 'src/layouts/DocLayout';
import { PushInventoryApiDoc } from 'src/containers/PushInventoryApiDoc';

export class PushInventoryApiDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
          <PushInventoryApiDoc />
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PushInventoryApiDocPage/index.tsx